import { goSolidApi } from "@/composables/useGoSolidApi";
import type {
  RegistryEventDetail,
  RegistryEventPage,
  RegistryEventsQuery,
} from "./transactionLogTypes";
import { EVENT_GROUP_WINDOW_MINUTES } from "./transactionRows";

export const transactionLogApi = {
  /**
   * `GET /api/registry/transaction-log/events`: one page of the companies' registry events that no
   * company order is connected to, in `sort_order` by occurrence. Pass the previous page's
   * `next_cursor` to read on. A page ends where the next event is more than `gap_minutes` away, so
   * each page can be grouped on its own; a run with no such gap for 1 000 events past the page size
   * is cut anyway, and the page reports `cut_inside_dense_stretch`. Errors propagate to the caller.
   */
  listEvents: (query: RegistryEventsQuery, cursor: string | null = null) =>
    goSolidApi.get<RegistryEventPage>("/api/registry/transaction-log/events", {
      params: {
        company_ids: query.company_ids.join(","),
        date_from: query.date_from ?? undefined,
        date_before: query.date_before ?? undefined,
        event_types: query.event_types.length
          ? query.event_types.join(",")
          : undefined,
        sort_order: query.sort_order,
        gap_minutes: EVENT_GROUP_WINDOW_MINUTES,
        cursor: cursor ?? undefined,
      },
    }),

  /**
   * `GET /api/registry/transaction-log/events/<id>`: one event, connected or not, with the company's
   * portfolio item records on its linked certificates, held or not; each item's `selected_count` is
   * the event's share of it. 404 when the event has no linked bundle. Errors propagate to the caller.
   */
  getEvent: (eventId: number) =>
    goSolidApi.get<RegistryEventDetail>(
      `/api/registry/transaction-log/events/${eventId}`
    ),
};
